import errorHandler from "../../../handlers/errorHandler";
import {
  setAllowedSitesReauthenticationRequired,
  setConnectNotice,
  setDiscoveryError,
} from "../allowedSitesSlice";
import { AUTH_REQUIRED } from "./allowedSitesConstants";

export const allowedSitesUrl = (isCloudMode, suffix = "") =>
  `${isCloudMode ? "/sharepoint/cloud" : "/sharepoint"}/allowed-sites${suffix}`;

export const errorCodeOf = (error) => error?.response?.data?.errorCode;

export const statusOf = (error) => error?.response?.status;

export const messageOf = (error, fallback) =>
  error?.response?.data?.message || fallback;

export const isSharepointError = (error) =>
  Boolean(errorCodeOf(error) || error?.response?.data?.error);

export const redirectUnlessSharepointError = (error) => {
  if (!isSharepointError(error)) {
    errorHandler(error?.response);
  }
};

export const connectNotice = (variant, message) =>
  setConnectNotice({ variant, message });

export const handleDiscoveryError = (dispatch, error) => {
  redirectUnlessSharepointError(error);
  if (errorCodeOf(error) === AUTH_REQUIRED || statusOf(error) === 401) {
    dispatch(setAllowedSitesReauthenticationRequired());
    return;
  }
  dispatch(
    setDiscoveryError(messageOf(error, "Could not load SharePoint sites"))
  );
};

export const asSiteRows = (rows = [], provenance) =>
  rows
    .filter((row) => row.id)
    .map(({ id, name, host, sitePath, lastModified }) => ({
      id,
      name,
      host,
      sitePath,
      lastModified: lastModified ?? null,
      provenance,
    }));
